import { HttpClient } from '@sisense/sdk-rest-client';
import OpenAI from 'openai';
import { createCustomFetch } from './create-custom-fetch';
import { normalizeUrl } from './utils';

const OPENAI_API_URL_PATH = 'api/v2/ai';

/**
 * Factory function to create an OpenAI client with custom configuration
 * @param baseURL - The base URL for the OpenAI API endpoint
 * @param fetchFn - Custom fetch function (e.g., with authentication headers)
 * @returns Configured OpenAI client instance
 */
export function createOpenAIClientHelper(
	baseURL: string,
	fetchFn: typeof fetch,
): OpenAI {
	return new OpenAI({
		// @ts-expect-error - OpenAI client requires apiKey but we're using custom auth
		apiKey: null,
		dangerouslyAllowBrowser: true,
		baseURL,
		fetch: fetchFn,
	});
}

export function createOpenAIClient(httpClient: HttpClient): OpenAI {
	const baseURL = normalizeUrl(httpClient.url) + OPENAI_API_URL_PATH;
	return createOpenAIClientHelper(baseURL, createCustomFetch(httpClient));
}
